<template>
    <div>
        <div class="mg-bottom10" style="max-width: 300px" :style="{'width':autoCropWidthHeight[0]+'px'}" v-if="img_lnk != '' || original_url != ''">
            <img class="fillw" :src="img_lnk == ''?original_url:img_lnk"/>
        </div>
        <div class="mg-bottom10" v-show="show_crop" :style="{height: this.crop_height, width: crop_width}">
            <VueCropper
                    ref="cropper2"
                    :img="crop_option.img"
                    :outputType="crop_option.outputType"
                    :info="crop_option.info"
                    :canScale="crop_option.canScale"
                    :autoCrop="crop_option.autoCrop"
                    :autoCropWidth="crop_option.autoCropWidth"
                    :autoCropHeight="crop_option.autoCropHeight"
                    :fixed="crop_option.fixed"
                    :fixedBox = "crop_option.fixedBox"
                    :fixedNumber="crop_option.fixedNumber"
                    :full="crop_option.full"
                    :mode="crop_option.mode"
                    :outputSize="crop_option.outputSize"
            ></VueCropper>
        </div>
        <div class="flex-box nopadding">
            <div class="mg-right5" v-show="!show_crop">
                <Button type="primary" @click="$refs['img_upload'].click()">{{this.$t("select")}}{{this.$t("img_lnk")}}</Button>
                <input type="file" ref="img_upload" v-show="false" id="upload2" accept="image/png, image/jpeg, image/gif, image/jpg"
                       @change="uploadCropImg($event)"/>
            </div>
            <div class="mg-right5" v-show="show_crop">
                <Button type="primary" @click="cancal">{{this.$t("cancel")}}</Button>
            </div>
            <div class="mg-right5" v-show="show_crop">
                <Button type="warning" @click="doCrop">{{this.$t("crop_pic")}}</Button>
            </div>
            <div class="f-blue" v-show="show_crop">
                {{this.$t("tips")}}：{{this.$t("scroll_mouse")}}
            </div>
        </div>
    </div>
</template>

<script>
    import {VueCropper} from 'vue-cropper'
    // import {client} from "../utils/configOss";
    let OSS = require('ali-oss');
    import moment from "moment"
    export default {
        name: 'myDropdown',
        data: function () {
            return {
                img_lnk:'',
                show_crop: false,
                crop_option: {
                    //img的路径自行修改
                    img: '',//require("../../src/assets/img/df_userimg.png"),
                    info: true, // 裁剪框的大小信息
                    outputType: 'jpeg',
                    canScale: true, // 图片是否允许滚轮缩放
                    autoCrop: true, // 是否默认生成截图框
                    autoCropWidth: this.autoCropWidthHeight[0], // 默认生成截图框宽度
                    autoCropHeight: this.autoCropWidthHeight[1], // 默认生成截图框高度
                    fixedBox: true, // 固定截图框大小 不允许改变
                    fixed: false, // 是否开启截图框宽高固定比例
                    infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                    // fixedNumber: this.fixedNumber, // 截图框的宽高比例
                    mode: '100%',
                    outputSize: 0.9,
                },
                file: {}
            }
        },
        props:{
            original_url: {
                default: "",
                type: String
            },
            // fixedNumber: {
            //     type: Array,
            //     default: function () {
            //         return [5,3]
            //     }
            // },
            autoCropWidthHeight: {
                type: Array,
                default: function () {
                    return [350,210]
                }
            },
            crop_width: {
                default:'80%'
            },
            crop_height: {
                default:'300px'
            },
            img_height: {
               default:'auto'
            },
            // 文件上传目录
            // org/info 组织形象照目录
            // org/build 组织建筑目录
            // org/cid 组织营业执照目录
            // goods/info 商品形象照
            path: {
                default: `other/${moment().format("YYYY-MM-DD")}`
            }
        },
        mounted: function(){
        },
        methods: {
            //取消
            cancal:function(){
                this.show_crop = false;
            },
            //点击裁剪，这一步是可以拿到处理后的地址
            doCrop (e) {
                e.stopPropagation();
                e.preventDefault();
                this.$refs["cropper2"].getCropBlob((data) => {
                    /*裁剪完后,发送base64地址到后端*/
                    if(data){
                        // 文件直接上传到阿里云oss
                        let fileNameArr = []
                        let fileNameLast = ''

                        // 在修改的时候需要把已经上传的文件，把文件名截取出来，再次上传的时候做覆盖处理。如果是添加不需要截取。
                        let fileNameStr = ''
                        fileNameArr = this.file.name.split('.')
                        fileNameLast = fileNameArr[fileNameArr.length - 1]
                        fileNameStr = this.file.name.substring(0, this.file.name.length - fileNameLast.length - 1) + moment().format("HHmmssSSS") + Math.ceil(Math.random() * 12345)
                        // 文件覆盖逻辑，暂时不需要用到
                        // {
                        //     fileNameArr = this.original_url.split('.')
                        //     fileNameLast = fileNameArr[fileNameArr.length - 1]
                        //     var fileNameStrArr = (fileNameArr[fileNameArr.length - 2]).split('/')
                        //     fileNameStr = fileNameStrArr[fileNameStrArr.length - 1]
                        //     console.log('fileNameArr', fileNameArr, fileNameStr)
                        // }
                        // 暂时只用other文件夹
                        // var fileName = `${this.path}/${fileNameStr}.${fileNameLast}`
                        var fileName = `other/${moment().format("YYYY-MM-DD")}/${fileNameStr}.${fileNameLast}`
                        console.log('fileName', fileName)
                        this.$base.showLoading();
                        this.$request.sendPost('com/get-upimg-key', {}, (success, data2, error) => {
                            if(success){
                                var client = new OSS({
                                    region: data2.region, //地域
                                    accessKeyId: data2.accessKeyId, //你自己的key和id
                                    accessKeySecret: data2.accessKeySecret,
                                    bucket: data2.bucket, //oss上你的存储空间名称
                                    secure: true,
                                })
                                client.multipartUpload(fileName, data).then(res => {
                                    this.$base.hideLoading();
                                    let url = res.res.requestUrls[0]
                                    if(url.indexOf("?") != -1){
                                        url = url.split("?")[0];
                                        console.log(url);
                                    }
                                    this.show_crop = false;
                                    this.img_lnk = url;
                                    this.$emit('cropImgUpload', url);
                                }).catch(err => {
                                    this.$base.msgErr(this.$t('upload_err'));
                                })
                            }
                            else {
                                this.$base.alertErr(error.errmsg);
                            }
                        })
                    }
                })
            },
            uploadCropImg (e) {
                //上传图片
                this.file = e.target.files[0];
                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                    alert(this.$t('img_upload_file_type_tip'));
                    return false;
                }
                var reader = new FileReader();
                reader.onload = (e) => {
                    let data;
                    data = e.target.result;
                    //console.log(data);
                    if (typeof e.target.result === 'object') {
                        // 把Array Buffer转化为blob 如果是base64不需要
                        data = window.URL.createObjectURL(new Blob([e.target.result]));
                    } else {
                        data = e.target.result
                    }
                    this.crop_option.img = data;
                    this.show_crop = true;
                    this.$refs["img_upload"].value=null;
                };
                reader.readAsDataURL(this.file);
            }
        }
    }
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/myCropImg.vue